import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

/**
 * 📊 SumUpWeekGql - Query pour récupérer les données agrégées d'une semaine
 *
 * ⚠️ IMPORTANT: Les données retournées sont COMPRESSÉES en Base64
 *
 * Usage pour décompression:
 * ```javascript
 * import {decompressFromBase64} from "../utils/compressUtil";
 *
 * const result = await executeQueryUtil(getSumUpWeekQuery(brandId, establishmentId, weekKey));
 *
 * // 🔍 OBLIGATOIRE: Décompresser le contenu avant utilisation
 * let content = result?.data?.getSumUpWeek?.content;
 * content = content && decompressFromBase64(content);
 * const parsed = content ? JSON.parse(content) : null;
 *
 * // 📈 Accès aux données
 * const totalTurnover = parsed?.totalTurnover || 0;
 * const detailbyStaff = parsed?.detailbyStaff || [];
 * ```
 *
 * 📅 Format weekKey attendu: "YYYY-W##-DD-MM" (ex: "2024-W12-18-03")
 * - YYYY: Année
 * - W##: Numéro de semaine ISO (01-53)
 * - DD-MM: Date de début et fin de semaine
 */

const common = `
  id
  content
  dayDate
`

/**
 * 🔧 Génère une query GraphQL pour récupérer les données d'une semaine spécifique
 *
 * @param {string} brandId - ID de l'enseigne
 * @param {string} establishmentId - ID de l'établissement
 * @param {string} week - Clé de la semaine au format "YYYY-W##-DD-MM"
 * @returns {DocumentNode} Query GraphQL prête à être exécutée
 *
 * 💡 Exemple d'usage:
 * ```javascript
 * const weekKey = "2024-W12-18-03"; // Semaine 12 de 2024
 * const query = getSumUpWeekQuery("brandId123", "establishmentId456", weekKey);
 * const result = await executeQueryUtil(query);
 * ```
 */
export const getSumUpWeekQuery = (brandId, establishmentId, week) => {
  var debug = `
    query {
      getSumUpWeek(brandId: "${brandId}", establishmentId: "${establishmentId}", sumUpWeekId:"${week}") {
        ${common}
      }
    }
  `
  console.log("📊 SumUpWeek Query:", debug);

  return gql`
    query {
      getSumUpWeek(brandId: "${brandId}", establishmentId: "${establishmentId}", sumUpWeekId:"${week}") {
        ${common}
      }
    }
  `;
}






